export default __webpack_public_path__ + "static/media/mongo.c964002e.png";